module.exports = __webpack_public_path__ + "static/media/checked.8e644bc4.svg";